import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { BillingType } from '~/components/BillModal/BillClientModal.types';
import { mapItemToCharge } from '~/components/BillModal/utils/lineItem.utils';
import { toDatestampString } from '~/models/time';
import { BillingScheduleType } from '~/types/api/billing/submit-charges';
export var NetTermsOption = /*#__PURE__*/ function(NetTermsOption) {
    NetTermsOption["Immediate"] = "immediate";
    NetTermsOption["Net7"] = "net7";
    NetTermsOption["Net15"] = "net15";
    NetTermsOption["Net30"] = "net30";
    NetTermsOption["Net45"] = "net45";
    NetTermsOption["Net60"] = "net60";
    return NetTermsOption;
}({});
export const netTermsFromOption = (option)=>{
    switch(option){
        case "immediate":
            return {
                type: 'immediate',
                days: null
            };
        case "net7":
            return {
                type: 'net',
                days: 7
            };
        case "net15":
            return {
                type: 'net',
                days: 15
            };
        case "net30":
            return {
                type: 'net',
                days: 30
            };
        case "net45":
            return {
                type: 'net',
                days: 45
            };
        case "net60":
            return {
                type: 'net',
                days: 60
            };
    }
};
const NET_DAYS_TO_OPTION = {
    7: "net7",
    15: "net15",
    30: "net30",
    45: "net45",
    60: "net60"
};
export const netTermsToOption = (netTerms)=>{
    var _NET_DAYS_TO_OPTION_netTerms_days;
    if (netTerms.type === 'immediate') return "immediate";
    return (_NET_DAYS_TO_OPTION_netTerms_days = NET_DAYS_TO_OPTION[netTerms.days]) !== null && _NET_DAYS_TO_OPTION_netTerms_days !== void 0 ? _NET_DAYS_TO_OPTION_netTerms_days : "immediate";
};
export const AD_HOC_PAYMENT_DEFAULTS = {
    coverCreditCardFees: false,
    netTerms: "immediate",
    includeTermsOfService: false,
    termsOfServiceId: ''
};
export var AdHocSendOption = /*#__PURE__*/ function(AdHocSendOption) {
    AdHocSendOption["SendByEmail"] = "send-by-email";
    AdHocSendOption["ShareByLink"] = "share-by-link";
    AdHocSendOption["MarkPaidExternally"] = "mark-paid-externally";
    return AdHocSendOption;
}({});
export const resolveSubmitSemantics = (param)=>{
    let { option, isFutureIssueDate } = param;
    switch(option){
        case "send-by-email":
            return {
                notify: 'notification',
                paymentCollection: 'anchor',
                billingScheduleType: isFutureIssueDate ? BillingScheduleType.ScheduleBill : BillingScheduleType.BillNow
            };
        case "share-by-link":
            return {
                notify: 'silent',
                paymentCollection: 'anchor',
                billingScheduleType: BillingScheduleType.BillNow
            };
        case "mark-paid-externally":
            return {
                notify: 'silent',
                paymentCollection: 'paidExternally',
                billingScheduleType: BillingScheduleType.BillNow
            };
    }
};
const buildLegalTermsDoc = (form, selectedLegalTerm)=>{
    if (!form.includeTermsOfService || !selectedLegalTerm) return null;
    const base = {
        legalTermsId: selectedLegalTerm.id,
        displayName: selectedLegalTerm.name,
        termsOfService: {
            type: 'none'
        }
    };
    switch(selectedLegalTerm.contentType){
        case 'pdf':
            return _object_spread_props(_object_spread({}, base), {
                type: 'pdf',
                pdf: {
                    pdfName: selectedLegalTerm.pdfUniqueName,
                    pdfFileName: selectedLegalTerm.pdfFileName
                }
            });
        case 'richText':
            var _selectedLegalTerm_richTextId;
            return _object_spread_props(_object_spread({}, base), {
                type: 'richText',
                richText: {
                    textId: (_selectedLegalTerm_richTextId = selectedLegalTerm.richTextId) !== null && _selectedLegalTerm_richTextId !== void 0 ? _selectedLegalTerm_richTextId : null
                }
            });
        case 'quill':
            var _selectedLegalTerm_richTextId1;
            return _object_spread_props(_object_spread({}, base), {
                type: 'quill',
                quill: {
                    textId: (_selectedLegalTerm_richTextId1 = selectedLegalTerm.richTextId) !== null && _selectedLegalTerm_richTextId1 !== void 0 ? _selectedLegalTerm_richTextId1 : null
                },
                contentOverride: {
                    type: 'none'
                }
            });
    }
};
export const mapFormToAdHocSubmitRequest = (param)=>{
    let { form, semantics, attachments, selectedLegalTerm, defaultEmailSubject, defaultEmailContent } = param;
    const outOfScopeCharges = form.items.filter((item)=>item.type === BillingType.Charge).map(mapItemToCharge);
    return {
        servicesListedInAgreement: [],
        outOfScopeCharges,
        billingDetails: {
            issueDate: toDatestampString(form.issueDate),
            type: semantics.billingScheduleType
        },
        attachments,
        adHocData: {
            netTerms: netTermsFromOption(form.netTerms),
            coverCreditCardFees: form.coverCreditCardFees,
            legalTermsDoc: buildLegalTermsDoc(form, selectedLegalTerm),
            notify: semantics.notify,
            paymentCollection: semantics.paymentCollection,
            issuedEmail: {
                subject: form.emailSubject || defaultEmailSubject,
                content: form.emailContent || defaultEmailContent
            }
        }
    };
};
